import RolesGuide from '../components/onboarding/RolesGuide';
import { Container, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';

const Roles = () => {
  return (
    <>
      <Helmet>
        <title>Roles | MindShare Calendar</title>
      </Helmet>
      <Container maxWidth="lg">
        <Typography variant="h4" gutterBottom>
          User Roles
        </Typography>
        
        <RolesGuide />
        
        {/* Rest of the existing content */}
      </Container>
    </>
  );
};

export default Roles; 